<script setup lang="ts">
/**
 * An account's avatar: the picture 账户资料 gave it, or else its name's
 * first letter on the theme colour — the navbar's, 安全中心's and the
 * tickets'. A picture that does not load falls back to the letter. Its
 * `trigger` slot is Arco's corner button (账户中心's camera). The same
 * file in both consoles.
 */
import { computed, ref, watch } from 'vue'

const props = withDefaults(defineProps<{ name?: string; src?: string; size?: number }>(), { name: '', src: '', size: 32 })
const initial = computed(() => ([...(props.name ?? '').trim()][0] ?? '').toUpperCase())
const broken = ref(false)
watch(
  () => props.src,
  () => (broken.value = false),
)
const picture = computed(() => !!props.src && !broken.value)
</script>

<template>
  <!-- Arco's avatar decides picture or text as it mounts: a new one when
       that changes. -->
  <a-avatar
    :key="picture ? src : 'letter'"
    :size="size"
    class="user-avatar"
    :class="{ picture }"
    :style="picture ? undefined : { backgroundColor: 'rgb(var(--primary-6))' }"
  >
    <img v-if="picture" :src="src" alt="" draggable="false" @error="broken = true" />
    <template v-else>{{ initial }}</template>
    <template v-if="$slots.trigger" #trigger-icon><slot name="trigger" /></template>
  </a-avatar>
</template>

<style scoped>
.user-avatar {
  flex: none;
}
/* A picture fills the circle, on the page's own ground while it loads. */
.user-avatar.picture {
  background-color: var(--color-fill-2);
}
.user-avatar img {
  object-fit: cover;
}
</style>
